module.exports = __webpack_public_path__ + "img/lion_paw_dark_1.aeb8191d.png";